import styled from "styled-components";
import "components/Zenvia/styles.scss";

export const Link = styled.a.attrs({
  //className: "relative animated fadeIn faster"
  className: "fixed z-5"
})`
  bottom: 20px;
  right: 40px;
`;

export const Content = styled.div`
  background-color: #0E4C54;
  border-radius: 40px;
  padding: 10px 15px 10px 50px;

  width: auto;
  min-width: auto;
  max-width: none;

  box-shadow: 7px 8px 0px -4px rgba(189,198,193,1);
`;


export const Description = styled.p`
  font-size: 11px;
  color: #FFFFFF;
`;

export const Tutorial = styled.p`
  font-size: 18px;
  color: #f7f762;
  font-weight: 600;
  line-height: 1.2;
  `;

export const Img = styled.img.attrs({
  className: "absolute"
})`
  width: auto !important;
  height: auto !important;
  left: -25px;
  top: -6px;
`;